import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  DateInput,
  LongTextInput,
  ReferenceManyField,
  EditButton,
  DateField,
  SelectInput,
  SelectField,
  EmailField,
  NumberField,
  ShowButton,
  Show,
  TabbedShowLayout,
  Tab,
  ArrayField,
  BooleanField,
  NumberInput,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  ReferenceArrayInput,
  SelectArrayInput,
  ChipField,
  ReferenceArrayField,
  SingleFieldList
} from 'react-admin';
import LocationInput from '../component/GooglePlace/LocationInput'

export const ImageFormatter = v => {
  // console.log("====LogoFormatter=====: ", v);
  if (typeof v === 'object') {
    return v;
  }
  const imageObj = {
    "src": v
  }
  return v
    ? imageObj
    : v;
}

export const ImageParser = v => {
  // console.log("====LogoParser=====: ", v);
  // console.log(v);
  if (typeof v === 'object') {
    return v;
  }

  return v.src
    ? v.src
    : v;
}

export const ImageArrayFormatter = v => {
  // console.log("====PhotoArrayFormatter=====: ", v);
  let photoArray = [];
  if (typeof v === 'undefined') {
    return v;
  }
  if (v.length && typeof v[0] !== 'object') {
    v.map(photo => {
      const imageObj = {
        "src": photo
      };

      photoArray.push(imageObj);
    })
    return photoArray;
  } else {
    return v;
  }

}

const required = (message = 'Required') =>
  value => value ? undefined : message;

const number = (message = 'More than 0') =>
  value => value && isNaN(Number(value)) && Number(value) > 0 ? message : undefined;

export const MessageList = (props) => (
  <List {...props} title="List of Messages" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="title"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const MessageCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/quick-messages">
      <TextInput source="title" validate={required()}/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const MessageEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/quick-messages">
      <FormTab label="Message Info">
        <TextInput source="title" validate={required()}/>
      </FormTab>
    </TabbedForm>
  </Edit>
);